import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "./store";
import { HashRouter, Route, Routes } from "react-router-dom";
import "./index.css";
import Login from "./Login";
import NoPage from "./NoPage";
import Logout from "./Logout";
import VerifyOtp from "./VerifyOtp";
import Home from "./Dashboard/Home";
import ProtectedRoute from "./ProtectedRoute";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Services from "./Dashboard/Services";
import Message from "./Dashboard/Message";
import Result from "./Dashboard/Result";
import TaskListener from './TaskListener';
import CBT from "./Dashboard/CBT";
import Make_CBT from "./Dashboard/Make_CBT";
import Login_cbt from "./CBT/Login";
import Home_CBT from "./CBT/Home";
import Logout_CBT from "./CBT/Logout";
import Start from "./CBT/Start";
import CBTConsole from "./Dashboard/CBTConsole";
import Control from "./Dashboard/Control";
import Account from "./Dashboard/Account";
import PaymentPage from "./Dashboard/PaymentPage";
import Exercise from "./Dashboard/Exercise";
import Make_Exercise from "./Dashboard/Make_Exercise";
import { StudentProfiles, TeacherProfiles } from "./Dashboard/Profile";

const App = () => {
  
  return (
    <>
      <Routes>
        <Route index path="/:id" element={<Login />} />
        <Route path="/:id/verify-otp" element={<VerifyOtp />} />

        {/* Protect Dashboard Route */}
        <Route element={<ProtectedRoute />}>
          <Route path="/:id/dashboard" element={<Home />} />
          <Route path="/:id/services" element={<Services />} />
          <Route path="/:id/message" element={<Message />} />
          <Route path="/:id/results" element={<Result />} />
          <Route path="/:id/cbt" element={<CBT />} />
          <Route path="/:id/cbt/create" element={<Make_CBT />} />
          <Route path="/:id/cbt/console/:cbtId" element={<CBTConsole />} />
          <Route path="/:id/control" element={<Control />} />
          <Route path="/:id/account" element={<Account />} />
          <Route path="/:id/pay/:payid" element={<PaymentPage />} />
          <Route path="/:id/exercise" element={<Exercise />} />
          <Route path="/:id/exercise/create" element={<Make_Exercise/>} />
          <Route path="/:id/profile/students" element={<StudentProfiles />} />
          <Route path="/:id/profile/teachers" element={<TeacherProfiles />} />
        </Route>

        <Route path="/:id/take-cbt" element={<Login_cbt />} />

        {/* Protect Dashboard Route */}
        <Route element={<ProtectedRoute />}>
          <Route path="/:id/take-cbt/home" element={<Home_CBT />} />
          <Route path="/:id/take-cbt/started" element={<Start />} />
        </Route>

        <Route path="/:id/logout" element={<Logout />} />
        <Route path="/:id/logout-cbt" element={<Logout_CBT />} />
        <Route path="*" element={<NoPage />} />
      </Routes>
    </>
  );
};

ReactDOM.render(
  <Provider store={store}>
    {/* Wrap App inside HashRouter */}
    <HashRouter>
      <App />
    </HashRouter>
    <ToastContainer />
    <TaskListener />
  </Provider>,
  document.getElementById("root")
);
